import { Component, Input } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { AssetService } from '../../models/assetservice.class';

import type { WorkflowFormField } from '../../../../enreport/src/app/class/assets/workflowstagedata.class';
@Component({
    selector: 'app-workflow-fields-input',
    templateUrl: './workflow-fields-input.component.html',
    standalone: false,
})
export class WorkflowFieldsInputComponent {
    @Input() field: WorkflowFormField;
    @Input() app: AssetService;
    @Input() bridge: AssetService;

    radioOptions = [
        { value: true, displayName: 'Yes' },
        { value: false, displayName: 'No' },
    ];

    trackByOptionsMethod(index: number): any {
        return index;
    }

    radioValueChanged = (field: WorkflowFormField, event: MatRadioChange) => {
        field.value = event.value;
    };
}
